import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import '../../../packages-pos/shared/theme.css'
import './styles.css'

// Light, always. This is a guest app: it opens from a printed QR code on a
// stranger's phone, once, for a few minutes, and we get no second chance and no
// support channel if it renders badly. Following prefers-color-scheme meant a
// diner whose phone is in dark mode got a theme nobody had tested on a real
// handset - and the header logo is chosen from this flag, so a mismatch made
// the branding vanish rather than merely look odd.
//
// The staff-facing apps still follow the system: those run on known devices,
// all day, by people who can tell us when something is wrong.
document.documentElement.dataset.theme = 'light'

createRoot(document.getElementById('root')).render(<App />)
